import { AxiosResponse } from "axios";

import RequestsService from "./requests.service";
import { APIRoutes } from "../http";
import { IAuthResult } from "../models/auth.model";
import { IResultResponse } from "../models/response/result.model";

interface IForgotPasswordChange {
  newPassword: string;
  resetPasswordToken: string;
}

function createAuthHash(username: string, password: string) {
  return Buffer.from(`${username}:${password}`).toString("base64");
}

export default class AuthService {
  static async login(
    login: string,
    password: string
  ): Promise<AxiosResponse<IResultResponse<IAuthResult>>> {
    return RequestsService.postMethod<IResultResponse<IAuthResult>>(
      APIRoutes.AUTH_LOGIN,
      null,
      {
        headers: {
          Authorization: `Basic ${createAuthHash(login, password)}`,
        },
      }
    );
  }

  static async forgotPasswordRequest(
    email: string
  ): Promise<AxiosResponse<IResultResponse<any>>> {
    return RequestsService.putMethod<IResultResponse<any>>(
      APIRoutes.AUTH_FORGOT_PASSWORD_REQUEST,
      { email }
    );
  }

  static async forgotPasswordChange(
    data: IForgotPasswordChange
  ): Promise<AxiosResponse<IResultResponse<any>>> {
    return RequestsService.putMethod<IResultResponse<any>>(
      APIRoutes.AUTH_FORGOT_PASSWORD_CHANGE,
      data
    );
  }
}
